import { useCallback } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

export const SORT_PARAM_NAME = "orderBy";

const sortToString = <T>(sort: Sort<T>): string => {
  return `${String(sort.column)}+${sort.direction}`;
};

const stringToSort = <T>(input: string | null): Sort<T> | null => {
  const splited = input?.split("+");

  if (splited === undefined || splited.length !== 2) {
    return null;
  } else {
    return {
      column: splited[0] as keyof T,
      direction: splited[1] === "asc" ? "asc" : "desc",
    };
  }
};

export const useSorting = <T>(): [Sort<T> | null, (sort: Sort<T>) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const sort = stringToSort(searchParams.get(SORT_PARAM_NAME));

  const setSort = useCallback(
    <T>(sort: Sort<T>) => {
      const stringSort = sortToString(sort);
      let newSearchParams = Array.from(searchParams);
      newSearchParams = [
        ...newSearchParams.filter(([key, value]) => key !== SORT_PARAM_NAME),
        [SORT_PARAM_NAME, stringSort],
      ];
      setSearchParams(newSearchParams, {
        replace: true,
        state: location.state,
      });
    },
    [searchParams]
  );

  return [sort, setSort];
};
